import { render, staticRenderFns } from "./D3wordcloud.vue?vue&type=template&id=9381be9a&"
import script from "./D3wordcloud.vue?vue&type=script&lang=ts&"
export * from "./D3wordcloud.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports